import { ATTACHMENT_TYPES, SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import BankAccount from "./BankAccount";
import ElectronicSignatureEligibility from "./electronicSignatureEligibility";
import EnrollmentCertificate from "./enrollmentCertificate";
import Id from "./Id";
import PaySlip from "./paySlip";
import ProfessionalBankAccount from "./ProfessionalBankAccount";
import SocialSecurityCertificate from "./SocialSecurityCertificate";

const generateProofForm = ({ isRia, supportingDocuments = [] }) => ({
  [SUBSCRIPTION_FORM_KEYS.PROOF.ID]: Id,
  [SUBSCRIPTION_FORM_KEYS.PROOF.BANK_ACCOUNT]: BankAccount,
  [SUBSCRIPTION_FORM_KEYS.PROOF.PROFESSIONAL_BANK_ACCOUNT]:
    supportingDocuments.includes(
      ATTACHMENT_TYPES.PROFESSIONAL_PAYMENT_ACCOUNT
    ) && ProfessionalBankAccount,
  [SUBSCRIPTION_FORM_KEYS.PROOF.SOCIAL_SECURITY_CERTIFICATE]:
    SocialSecurityCertificate,
  [SUBSCRIPTION_FORM_KEYS.PROOF.PAY_SLIP]:
    supportingDocuments.includes(ATTACHMENT_TYPES.PAY_SLIP) && PaySlip,
  [SUBSCRIPTION_FORM_KEYS.PROOF.ELECTRONIC_SIGNATURE_ELIGIBILITY]:
    isRia && ElectronicSignatureEligibility,
  [SUBSCRIPTION_FORM_KEYS.PROOF.ENROLLMENT_CERTIFICATE]:
    supportingDocuments.includes(
      ATTACHMENT_TYPES.STUDENT_ID_OR_ENROLLMENT_CERTIFICATE
    ) && EnrollmentCertificate,
});

export default generateProofForm;
